// @flow

import { observer } from "mobx-react";
import * as React from "react";
import TimeAgo from "react-timeago";

import TextExtractor from "app/util/TextExtractor";
import TimelineItem from "app/models/TimelineItem";
import Video from "app/models/Video";

import Overlay from "app/components/Overlay/Overlay";
import TimelineCardSocial from "app/components/TimelineCardSocial/TimelineCardSocial";
import TimelineConversation from "app/components/TimelineConversation/TimelineConversation";
import VideoAuthor from "app/components/VideoAuthor/VideoAuthor";
import User from "app/models/User";
import "./TimelineItemOverlay.scss";

type Props = {
    video: Video,
    userId: ?number,
    user: ?User,
    item: TimelineItem,
    onComment: Function,
    onDeleteComment: Function,
    onReact: Function,
    onClose: Function,
    children: React.Node,
    serverTime: any,
    overlayVisible: boolean
};

@observer
export default class TimelineItemOverlay extends React.Component<Props> {
    get comment(): ?string {
        const item = this.props.item;
        let comment = item.comment;
        if (!comment) return null;

        comment = TextExtractor.linkify(
            comment,
            `/content/clickthrough/${item.rowid}/`
        );
        comment = TextExtractor.breakLines(comment);

        return comment;
    }

    render() {
        const item = this.props.item;
        const video = this.props.video;
        const classes = ["TimelineItemOverlay"];
        if (this.props.overlayVisible) {
            classes.push("TimelineItemOverlay_scale");
        }

        return (
            <div className={classes.join(" ")}>
                <Overlay active={true} onClick={this.props.onClose} />

                <div className="TimelineItemOverlay__body row">
                    <button
                        type="button"
                        onClick={this.props.onClose}
                        className="TimelineItemOverlay__cancel"
                    >
                        <i className="fa fa-remove fa-2x" />
                    </button>

                    <div className="TimelineItemOverlay__content col-md-9">
                        {this.props.children}
                    </div>

                    <div className="TimelineItemOverlay__panel col-md-3">
                        <div className="TimelineItemOverlay__panel__card">
                            <button
                                type="button"
                                onClick={this.props.onClose}
                                className="TimelineItemOverlay__cancel"
                            >
                                <i className="fa fa-remove fa-2x" />
                            </button>

                            <div className="TimelineItemOverlay__author">
                                <div className="TimelineItemOverlay__author__content">
                                    <VideoAuthor
                                        name={video.author_name || undefined}
                                        image={this.getUserImage(video)}
                                    />

                                    <div className="TimelineItemOverlay__timeago">
                                        <TimeAgo
                                            date={item.created_at || ""}
                                            now={() => this.props.serverTime}
                                            title={item.created_at || ""}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div
                                className="TimelineItemOverlay__comment"
                                dangerouslySetInnerHTML={{
                                    __html: this.comment
                                }}
                            />

                            <TimelineCardSocial
                                item={this.props.item}
                                userId={this.props.userId}
                                onDeleteComment={this.props.onDeleteComment}
                                onReact={this.props.onReact}
                            />
                        </div>

                        <TimelineConversation
                            userId={this.props.userId}
                            user={this.props.user}
                            comments={item.comments}
                            onDelete={this.props.onDeleteComment}
                            onComment={this.props.onComment}
                            serverTime={this.props.serverTime}
                        />
                    </div>
                </div>
            </div>
        );
    }

    getUserImage(video: Video) {
        return video.author_image || undefined;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineItemOverlay/TimelineItemOverlay.js